import Autocomplete from "react-autocomplete";
import React, { Component } from 'react';
class Directory extends Component {

    constructor(props) {
      super(props);
      this.state = {
        menuData: [],
        value:"",
        open:false,
        item:'',
        loading: true,
        error: false,
      };
    }
    requestTimer = null; 
    clearField(event){
        event.target.placeholder='';
    }    
  getNewData(value){
    const queryValue=value.replace(/ /g, "+");
    const url = `https://www.uvm.edu/directory/api/query_suggestions.php?name=`+queryValue;
    
    fetch(url,{
        // mode: 'no-cors',
        method: 'GET',
        headers: {
          Accept: 'application/json',
        },
      },)
    .then(response => response.json())
    .then(data => {
      this.setState({
        menuData:data.data
      })
    })
    .catch((error) => this.setState({ loading: false, error }));
    return value;
    }
  
    render() {
      return (
        <Autocomplete
        inputProps={{ 
          tabIndex:"-1",
            name:'search',
            id: 'search', 
            placeholder:'Who do you want to find?', 
            style: { 
                height: "38px",
                maxWidth: "442px",
                width: "100%",
                border: "2px solid #B4CF47",
                fontSize:"16px",
                backgroundColor:"transparent"
            },
            onFocus:this.clearField 
        }}
        wrapperStyle={{ position: 'relative',display: 'inline-block', width:"100%" }}
        const value={this.state.value}
        items={this.state.menuData}
        menuStyle={{
            position: "absolute",
            boxSizing: "border-box",
            width: "100%",
            border: "1px solid #cccccc",
            backgroundColor: "#ccc"
        }}
        getItemValue={(item) => item}
        onSelect={(value, item) => {
          this.setState({ value, menuData: [] })
           }}
        onChange={(event,value) => {
            value=this.getNewData(value);
            this.setState({ value });
           
          }}
        renderMenu={children => (
          <div className="menu">
            {children}
          </div>
        )}
        renderItem={(item, isHighlighted) => (
          <div
            className={`item ${isHighlighted ? 'item-highlighted' : ''}`}
            key={item}
          >{item}</div>
        )}
      />
        );
  }
}
  export default Directory;
  